module.exports = __webpack_public_path__ + "static/media/icon_nosotros_contacto.fb3e6c31.svg";